import { $ } from "../shared/jquery-globals";
import { ProductFilter } from "../modules/product-filter";
import FilterCollapse from "../modules/filter-collapse";
import { MobileFilterDrawer } from "../modules/mobile-filter-drawer";
import ProductUomSelector from "../modules/product-uom-selector";
import ProductVariantSelector from "../modules/product-variant-selector";
import AddToCartButton from "../modules/product-add-to-cart.js";
import AddToWishlistButton from "../modules/product-add-to-wishlist.js";
import "../modules/wishlist-manager.js";
import VariantHelper from "../modules/variant-helper";
import RecentlyViewedProducts from "../modules/recently-viewed-products.js";
import ProductQuickView from "../modules/product-quick-view.js";
import ProductQuickAddToCart from "../modules/product-quick-add-to-cart.js";
import ProductSorter from "../modules/product-sorter.js";
import ProductDetailTabs from "../product-detail-tabs.js";
import ProductReviewWriteButton from "../modules/product-review-write-button.js";

window.ProductFilter = ProductFilter;
window.FilterCollapse = FilterCollapse;
window.MobileFilterDrawer = MobileFilterDrawer;
window.VariantHelper = VariantHelper;
window.productFilters = window.productFilters || {};

$(async function () {
  if ($(".product-variant-selector").length) {
    $(".product-variant-selector").each(function () {
      const selector = new ProductVariantSelector(this);
      selector.init();
    });
  }

  if ($(".product-uoms-container").length) {
    $(".product-uoms-container").each(function () {
      const selector = new ProductUomSelector(this);
      selector.init();
    });
  }

  if ($(".add-to-cart-btn").length) {
    $(".add-to-cart-btn").each(function () {
      new AddToCartButton(this);
    });
  }

  if ($(".add-to-wishlist-btn").length) {
    if (
      window.WishlistManager &&
      typeof window.WishlistManager.init === "function"
    ) {
      try {
        await window.WishlistManager.init();
      } catch {
        $(".add-to-wishlist-btn").each(function () {
          new AddToWishlistButton(this);
        });
      }
    } else {
      $(".add-to-wishlist-btn").each(function () {
        new AddToWishlistButton(this);
      });
    }
  }

  if (
    $(".remove-viewed-product").length ||
    $("#clear-all-viewed-products").length
  ) {
    window.recentlyViewedProducts = new RecentlyViewedProducts();
  }

  if (!window.productQuickView) {
    window.productQuickView = new ProductQuickView();
  }

  if (!window.productQuickAddToCart) {
    window.productQuickAddToCart = new ProductQuickAddToCart();
  }

  if ($("#product-sorter").length) {
    new ProductSorter(document.getElementById("product-sorter"));
  }

  if ($(".product-detail-tab-wrapper").length) {
    new ProductDetailTabs();
  }

  if ($('button[data-product-id][id="write-review-button"]').length) {
    new ProductReviewWriteButton().init();
  }

  const viewModeButtons = document.querySelectorAll(".view-mode-btn");
  const productListContainer = document.querySelector("#product-list");
  let currentViewMode =
    window.localStorage?.getItem("productViewMode") || "grid-2";

  function initViewMode() {
    viewModeButtons.forEach((btn) => {
      btn.classList.remove("active");
      if (btn.dataset.view === currentViewMode) {
        btn.classList.add("active");
      }
    });

    if (productListContainer) {
      productListContainer.className = productListContainer.className.replace(
        /view-\w+/g,
        ""
      );
      productListContainer.classList.add(`view-${currentViewMode}`);
    }
  }

  viewModeButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const viewMode = this.dataset.view;

      viewModeButtons.forEach((button) => button.classList.remove("active"));
      this.classList.add("active");

      if (productListContainer) {
        productListContainer.className = productListContainer.className.replace(
          /view-\w+/g,
          ""
        );
        productListContainer.classList.add(`view-${viewMode}`);
      }

      window.localStorage?.setItem("productViewMode", viewMode);
      currentViewMode = viewMode;
    });
  });

  initViewMode();
});

window.addEventListener("product:option-changed", function (event) {
  const { selectedOptionValues, selectedVariant, selectedUomId } =
    event.detail;

  updateProductGallery(selectedOptionValues, selectedVariant, selectedUomId);
});

window.addEventListener("productListUpdated", (event) => {
  const { hasNewContent } = event.detail;

  if (
    hasNewContent &&
    window.WishlistManager &&
    typeof window.WishlistManager.reinitializeButtons === "function"
  ) {
    window.WishlistManager.reinitializeButtons().catch(() => {
      // Ignore wishlist refresh errors after product list updates.
    });
  }
});

function updateProductGallery(
  selectedOptionValues,
  selectedVariant,
  selectedUomId
) {
  const mainGallery = document.querySelector(
    '[data-swiper-id="product-gallery-main-gallery"]'
  );
  const thumbnailsGallery = document.getElementById(
    "product-gallery-thumbnails"
  );

  if (!mainGallery || !thumbnailsGallery) {
    return;
  }

  const selectedOptionValueIds = selectedOptionValues
    ? selectedOptionValues.map((opt) => opt.option_value_id)
    : [];

  if (
    selectedOptionValueIds.length === 0 &&
    !selectedVariant &&
    !selectedUomId
  ) {
    showAllImages();
    return;
  }

  const allSlides = mainGallery.querySelectorAll(".swiper-slide");
  const matchingSlides = [];

  allSlides.forEach((slide, index) => {
    const slideTags = slide.getAttribute("data-tags");
    if (!slideTags) return;

    const tags = slideTags
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);

    let shouldShow = false;

    if (selectedVariant) {
      const variantTag = `variant_${selectedVariant.id}`;
      if (tags.includes(variantTag)) {
        shouldShow = true;
      }
    }

    if (!shouldShow && selectedUomId) {
      const uomTag = `uom_${selectedUomId}`;
      if (tags.includes(uomTag)) {
        shouldShow = true;
      }
    }

    if (!shouldShow && selectedOptionValueIds.length > 0) {
      const hasOptionMatch = selectedOptionValueIds.some((optionValueId) => {
        const optionTag = `product_option_value_${optionValueId}`;
        return tags.includes(optionTag);
      });

      if (hasOptionMatch) {
        shouldShow = true;
      }
    }

    if (shouldShow) {
      matchingSlides.push({ slide, index });
    }
  });

  if (matchingSlides.length === 0) {
    showAllImages();
    return;
  }

  allSlides.forEach((slide) => {
    const isMatching = matchingSlides.some((match) => match.slide === slide);

    if (isMatching) {
      slide.style.display = "block";
      slide.classList.remove("swiper-slide-hidden");
    } else {
      slide.style.display = "none";
      slide.classList.add("swiper-slide-hidden");
    }
  });

  const allThumbSlides = thumbnailsGallery.querySelectorAll(".swiper-slide");
  allThumbSlides.forEach((slide) => {
    const slideTags = slide.getAttribute("data-tags");
    if (!slideTags) return;

    const tags = slideTags
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);

    let shouldShow = false;

    if (selectedVariant) {
      const variantTag = `variant_${selectedVariant.id}`;
      if (tags.includes(variantTag)) {
        shouldShow = true;
      }
    }

    if (!shouldShow && selectedUomId) {
      const uomTag = `uom_${selectedUomId}`;
      if (tags.includes(uomTag)) {
        shouldShow = true;
      }
    }

    if (!shouldShow && selectedOptionValueIds.length > 0) {
      const hasOptionMatch = selectedOptionValueIds.some((optionValueId) => {
        const optionTag = `product_option_value_${optionValueId}`;
        return tags.includes(optionTag);
      });

      if (hasOptionMatch) {
        shouldShow = true;
      }
    }

    if (shouldShow) {
      slide.style.display = "block";
      slide.classList.remove("swiper-slide-hidden");
    } else {
      slide.style.display = "none";
      slide.classList.add("swiper-slide-hidden");
    }
  });

  const mainSwiper = mainGallery.swiper;
  const thumbsSwiper = thumbnailsGallery.swiper;

  if (!mainSwiper || !thumbsSwiper) {
    return;
  }

  mainSwiper.updateSize();
  mainSwiper.updateSlides();
  mainSwiper.updateProgress();
  mainSwiper.updateSlidesClasses();

  thumbsSwiper.updateSize();
  thumbsSwiper.updateSlides();
  thumbsSwiper.updateProgress();
  thumbsSwiper.updateSlidesClasses();

  mainSwiper.update();
  thumbsSwiper.update();

  const visibleSlideMap = [];
  allSlides.forEach((slide, index) => {
    if (slide.style.display !== "none") {
      visibleSlideMap.push(index);
    }
  });

  setTimeout(() => {
    mainSwiper.slideTo(0, 0);
    thumbsSwiper.slideTo(0, 0);
  }, 200);

  mainGallery.dataset.visibleSlideMap = JSON.stringify(visibleSlideMap);
  thumbnailsGallery.dataset.visibleSlideMap = JSON.stringify(visibleSlideMap);

  addThumbnailClickHandlers(mainSwiper, thumbsSwiper, visibleSlideMap);
}

function showAllImages() {
  const mainGallery = document.querySelector(
    '[data-swiper-id="product-gallery-main-gallery"]'
  );
  const thumbnailsGallery = document.getElementById(
    "product-gallery-thumbnails"
  );

  if (!mainGallery || !thumbnailsGallery) {
    return;
  }

  const allSlides = mainGallery.querySelectorAll(".swiper-slide");
  allSlides.forEach((slide) => {
    slide.style.display = "block";
    slide.classList.remove("swiper-slide-hidden");
  });

  const allThumbSlides = thumbnailsGallery.querySelectorAll(".swiper-slide");
  allThumbSlides.forEach((slide) => {
    slide.style.display = "block";
    slide.classList.remove("swiper-slide-hidden");
  });

  const mainSwiper = mainGallery.swiper;
  const thumbsSwiper = thumbnailsGallery.swiper;

  if (!mainSwiper || !thumbsSwiper) {
    return;
  }

  mainSwiper.updateSize();
  mainSwiper.updateSlides();
  mainSwiper.updateProgress();
  mainSwiper.updateSlidesClasses();

  thumbsSwiper.updateSize();
  thumbsSwiper.updateSlides();
  thumbsSwiper.updateProgress();
  thumbsSwiper.updateSlidesClasses();

  mainGallery.removeAttribute("data-visible-slide-map");
  thumbnailsGallery.removeAttribute("data-visible-slide-map");

  mainSwiper.update();
  thumbsSwiper.update();

  setTimeout(() => {
    mainSwiper.slideTo(0, 0);
    thumbsSwiper.slideTo(0, 0);
  }, 200);
}

function addThumbnailClickHandlers(mainSwiper, thumbsSwiper, visibleSlideMap) {
  const thumbnailsGallery = document.getElementById(
    "product-gallery-thumbnails"
  );
  if (!thumbnailsGallery) {
    return;
  }

  const existingThumbnails = thumbnailsGallery.querySelectorAll(".swiper-slide");
  existingThumbnails.forEach((slide) => {
    slide.removeEventListener("click", slide._thumbnailClickHandler);
  });

  existingThumbnails.forEach((slide, index) => {
    const clickHandler = (event) => {
      event.preventDefault();

      const visibleIndex = visibleSlideMap.indexOf(index);
      if (visibleIndex !== -1) {
        mainSwiper.slideTo(visibleIndex, 300);
        thumbsSwiper.slideTo(visibleIndex, 300);
      }
    };

    slide._thumbnailClickHandler = clickHandler;
    slide.addEventListener("click", clickHandler);
  });
}
